import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  publishedBySection: {
    textAlign: 'center',

    '& img': {
      display: 'block',
      height: 50,
      marginRight: 'auto',
      marginBottom: theme.spacing(4),
      marginLeft: 'auto',

      [theme.breakpoints.up('sm')]: {
        display: 'inline-block',
        marginRight: theme.spacing(4),
        marginLeft: 0,
      },
    },
  },
  title: {
    color: '#7833FF',
    fontSize: 18,
    fontFamily: 'Lato',
    marginBottom: theme.spacing(4),
    padding: theme.spacing(0, 2),
  },
}));
